type SsoMessageKey = "login.ssoErrors.cancelled" | "login.ssoErrors.providerUnavailable" | "login.ssoErrors.failed";

const KEY_BY_FAILURE: Record<string, SsoMessageKey> = {
  cancelled: "login.ssoErrors.cancelled",
  provider_unavailable: "login.ssoErrors.providerUnavailable",
  login_failed: "login.ssoErrors.failed",
};

export function resolveSsoErrorKey(failure: string): SsoMessageKey {
  return KEY_BY_FAILURE[failure] ?? "login.ssoErrors.failed";
}
